import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const ColorSelectionTaskAttemptSchema = z.object({
  type: z.literal(TaskType.COLOR_SELECTION),
  colorSelection: z.string(),
  dripEdgeColorSelection: z.string().max(191).optional(),
  dripEdgeColorSourcingConfirmed: z.boolean().optional(),
  numberOfLayers: z.number().optional(),
  schedulingAvailabilityNotes: z.string().nullish(),
  satelliteNotes: z.string().nullish(),
  hasProofOfColorChoice: z.boolean().optional(),
});

export type ColorSelectionTaskAttempt = z.infer<typeof ColorSelectionTaskAttemptSchema>;

export const ColorSelectionTaskAttemptFormSchema = ColorSelectionTaskAttemptSchema.extend({
  colorSelection: z.string().trim().min(1),
});
